{
  "global": {
    "class": "className",
    "id": true,
    "title": true,
    "dir": true,
    "lang": true
  },
  "tags": {
    "p": {},
    "br": {
      "children": false
    },
    "span": {
      "attributes": {
        "translate": true
      }
    },
    "a": {
      "attributes": {
        "href": true,
        "rel": true,
        "translate": true,
        "target": true,
        "title": true
      }
    },
    "abbr": {
      "attributes": {
        "title": true
      }
    },
    "del": {},
    "s": {},
    "pre": {},
    "blockquote": {
      "attributes": {
        "cite": true
      }
    },
    "code": {},
    "b": {},
    "strong": {},
    "u": {},
    "sub": {},
    "sup": {},
    "i": {},
    "img": {
      "children": false,
      "attributes": {
        "src": true,
        "alt": true,
        "title": true
      }
    },
    "em": {},
    "h1": {},
    "h2": {},
    "h3": {},
    "h4": {},
    "h5": {},
    "ul": {},
    "ol": {
      "attributes": {
        "start": true,
        "reversed": true
      }
    },
    "li": {
      "attributes": {
        "value": true
      }
    },
    "ruby": {},
    "rt": {},
    "rp": {}
  }
}
